<app-drop-down-view
  [defaultState]="animated"
  [title]="'SEARCH_MODULE.LOCATION_SEARCH.SELECT_DATES' | transloco"
  [showFooter]="true"
  [slide]="slide"
  [skeleton]="true"
  [closeType]="closeType">
  <div class="searchBarMobileCalendar__cont__date-calendar" content>
    <app-ds-date-calendar
      [type]="dateCalendarType"
      [inputsVisible]="dateCalendarEnabledInputs$ | async"
      [timeToScroll]="timeToSlide"
      [inputsLabel]="{ left: departurePlaceholder, right: returnPlaceholder }"
      [inputsPlaceholder]="{ left: departurePlaceholder, right: returnPlaceholder }"
      [defaultField]="fieldActivated"
      [isOnlyOneDate]="isOneWayTrip$ | async"
      [scrollToDefaultDate]="true"
      [allowSameDateSelection]="allowTheSameDay"
      [defaultDates]="defaultDates$ | async"
      [minDate]="minDate"
      [maxDate]="maxDate"
      [locale]="localeByLanguage"
      (selectEvent)="selectEvent($event)">
      <app-calendar-inputs
        [searchType]="searchType"
        [flightType]="flightType$ | async"
        (selectFlightType)="selectFlightType($event)">
      </app-calendar-inputs>
    </app-ds-date-calendar>
  </div>
  <div class="searchBarMobileCalendar__cont__button" footer>
    <app-ds-button
      [isDisabled]="(isValidDateCalendar$ | async) === false"
      [labels]="{ ButtonLabel: daysBetweenTwoDatesLabel | transloco : { days: daysBetweenTwoDates } }"
      (clickEvent)="close()">
    </app-ds-button>
  </div>
</app-drop-down-view>
